import http from '@/shared/api/http'
import type { ApiResponse } from '@/shared/api/http/api/response.api'
import type {
  DocumentsByMonthItem,
  DocumentsByStatusItem,
  DocumentsByTypeItem,
  DossiersByStatusItem,
  IssueWaitingAgeItem,
  IssuedByDossierTypeItem,
  IssuedWeekItem,
  MyDossierItem,
  MyDossierTypeItem,
  OutboxStatusItem,
  OverviewKpisResponse,
  PendingSignatureItem,
  PendingSignatureSummary,
  SignWeekItem,
  TrustedCaExpiryItem,
} from '../types'

export const DASHBOARD_URLS = {
  overviewKpis: '/api/dashboard/overview-kpis',
  documentsByStatus: '/api/dashboard/documents-by-status',
  documentsByMonth: '/api/dashboard/documents-by-month',
  documentsByType: '/api/dashboard/documents-by-type',
  dossiersByStatus: '/api/dashboard/dossiers-by-status',
  myPendingSignatures: '/api/dashboard/my-pending-signatures',
  myDocuments: '/api/dashboard/my-documents',
  myDossiers: '/api/dashboard/my-dossiers',
  issueWaitingAge: '/api/dashboard/issue-waiting-age',
  issuedByDossierType: '/api/dashboard/issued-by-dossier-type',
  issuedByWeek: '/api/dashboard/issued-by-week',
  outboxStatus: '/api/dashboard/outbox-status',
  trustedCaExpiry: '/api/dashboard/trusted-ca-expiry',
  mySignActivity: '/api/dashboard/my-sign-activity',
} as const

export const dashboardService = {
  getOverviewKpis: (): Promise<ApiResponse<OverviewKpisResponse>> =>
    http.get(DASHBOARD_URLS.overviewKpis, { skipGlobalError: true }),

  getDocumentsByStatus: (): Promise<ApiResponse<DocumentsByStatusItem[]>> =>
    http.get(DASHBOARD_URLS.documentsByStatus, { skipGlobalError: true }),

  getDocumentsByMonth: (): Promise<ApiResponse<DocumentsByMonthItem[]>> =>
    http.get(DASHBOARD_URLS.documentsByMonth, { skipGlobalError: true }),

  getDocumentsByType: (): Promise<ApiResponse<DocumentsByTypeItem[]>> =>
    http.get(DASHBOARD_URLS.documentsByType, { skipGlobalError: true }),

  getDossiersByStatus: (): Promise<ApiResponse<DossiersByStatusItem[]>> =>
    http.get(DASHBOARD_URLS.dossiersByStatus, { skipGlobalError: true }),

  getMyPendingSignatures: (): Promise<
    ApiResponse<PendingSignatureItem[] | PendingSignatureSummary>
  > => http.get(DASHBOARD_URLS.myPendingSignatures, { skipGlobalError: true }),

  getOutboxStatus: (): Promise<ApiResponse<OutboxStatusItem[]>> =>
    http.get(DASHBOARD_URLS.outboxStatus, { skipGlobalError: true }),

  getTrustedCaExpiry: (): Promise<ApiResponse<TrustedCaExpiryItem[]>> =>
    http.get(DASHBOARD_URLS.trustedCaExpiry, { skipGlobalError: true }),

  getMySignActivity: (): Promise<ApiResponse<SignWeekItem[]>> =>
    http.get(DASHBOARD_URLS.mySignActivity, { skipGlobalError: true }),

  getIssueWaitingAge: (): Promise<ApiResponse<IssueWaitingAgeItem[]>> =>
    http.get(DASHBOARD_URLS.issueWaitingAge, { skipGlobalError: true }),

  getIssuedByDossierType: (): Promise<ApiResponse<IssuedByDossierTypeItem[]>> =>
    http.get(DASHBOARD_URLS.issuedByDossierType, { skipGlobalError: true }),

  getIssuedByWeek: (): Promise<ApiResponse<IssuedWeekItem[]>> =>
    http.get(DASHBOARD_URLS.issuedByWeek, { skipGlobalError: true }),

  getMyDossiers: (): Promise<ApiResponse<MyDossierItem[]>> =>
    http.get(DASHBOARD_URLS.myDossiers, { skipGlobalError: true }),

  getMyDossierTypes: (): Promise<ApiResponse<MyDossierTypeItem[]>> =>
    http.get(DASHBOARD_URLS.myDocuments, { skipGlobalError: true }),
}
